import { render, staticRenderFns } from "./change_password_part.vue?vue&type=template&id=10c7c349&lang=pug&"
import script from "./change_password_part.vue?vue&type=script&lang=coffee&"
export * from "./change_password_part.vue?vue&type=script&lang=coffee&"
import style0 from "./change_password_part.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports